import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import ModalImage from "react-modal-image";
import { doc, getDoc } from "firebase/firestore";
import bg1 from "../../assets/images/bg/photos.jpg";
import bg from "../../assets/images/bg/photos-m.jpg";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";
import { firestore } from "../../Config/FbConfig";

const ITEMS_PER_PAGE = 6; // Number of items per page

export default function PhotoList() {
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();
  const [Blog, setBlog] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = useState(false);
  const [bgImage, setBgImage] = useState(window.innerWidth <= 768 ? bg : bg1);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [currentPage, setCurrentPage] = useState(1); // Current page state

  const matchedItems = Blog?.filter(
    (item) => item.Categories === state?.category
  );

  useEffect(() => {
    const handleResize = () => {
      setBgImage(window.innerWidth <= 768 ? bg : bg1);
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [bg, bg1]);

  useEffect(() => {
    const fetch_1 = async () => {
      setLoading(true);
      try {
        const docRef = doc(firestore, "Other", "Gallery");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const Data = [];
          Object.entries(docSnap.data()).forEach(([key, value]) => {
            Data.push(Object.assign({ Id: key }, value));
          });
          const sortedData = Data.sort((a, b) => a.Priority - b.Priority);
          setBlog(sortedData);
          setNoData(sortedData.length === 0);
        } else {
          setBlog([]);
          setNoData(true);
        }
      } catch (error) {
        console.error("Error fetching gallery photos: ", error);
        setNoData(true);
      } finally {
        setLoading(false);
      }
    };

    fetch_1();
  }, []);

  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const currentItems = matchedItems.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(matchedItems.length / ITEMS_PER_PAGE);

  return (
    <>
      <Navbar
        manuClass="navigation-menu nav-light nav-left"
        containerClass="container"
      />
      <section
        className="bg-half-170 d-table w-100"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          marginTop: isMobile ? "2rem" : "",
        }}
      >
        <div
          className="bg-overlay bg-overlay-dark"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        ></div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title text-center">
                <h3 className="sub-title text-white title-dark">
                  Gallery Photos
                </h3>
                <p className="para-desc mx-auto text-white-50">
                  Theatre is where stories come alive and humanity finds its
                  voice
                </p>
                <nav aria-label="breadcrumb" className="d-inline-block">
                  <ul className="breadcrumb bg-light rounded mb-0 py-1 px-2">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li style={{color:"#B9B569"}} className="breadcrumb-item active" aria-current="page">
                      Gallery Photos
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ marginBottom: "1.5rem" }}>
        <div className="container">
          {loading ? (
            <div className="text-center">
              <p>Loading...</p>
            </div>
          ) : noData ? (
            <div className="text-center">
              <h5>No Photos Available</h5>
            </div>
          ) : (
            <>
              <div>
                <h3
                  style={{
                    textTransform: "capitalize",
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "2rem",
                  }}
                >
                  {state?.category}
                </h3>
              </div>
              <div style={{ marginBottom: "1.5rem" }}>
                <button
                  style={{ backgroundColor: "#B9B568", border: "#B9B568" }}
                  onClick={() => {
                    navigate("/gallery-photos");
                  }}
                  className="btn btn-primary"
                >
                  Go Back
                </button>
              </div>
              <div className="row">
                {currentItems?.map((items, index) => (
                  <div
                    className="col-lg-4 col-md-6 col-12 mb-4 pb-2"
                    key={index}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card blog blog-primary border-0 shadow rounded overflow-hidden">
                      <ModalImage small={items.Image} large={items.Image} />
                    </div>
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "1rem",
                        textTransform: "capitalize",
                      }}
                      className="justify six-line-truncate"
                    >
                      {items.Description}
                    </p>
                  </div>
                ))}
              </div>
            </>
          )}
          <div className="d-flex justify-content-center mt-4">
            <nav>
              <ul className="pagination">
                {Array.from({ length: totalPages }, (_, index) => (
                  <li
                    key={index}
                    className={`page-item ${
                      currentPage === index + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      onClick={() => paginate(index + 1)}
                      style={{ backgroundColor: "#B9B568" }}
                      className="page-link"
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      </section>
      <Footer />
      <ScrollTop />
    </>
  );
}
